import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { key: "form" }
const _hoisted_2 = { key: "paymentSystem" }
const _hoisted_3 = {
  key: "finish",
  class: "text-center"
}
const _hoisted_4 = { class: "mt-4 mb-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "c" }
const _hoisted_8 = ["textContent"]

import PaymentSumSelector from "~/chat/vue/widget/tabs/payment/PaymentSumSelector.vue";
import ChatForm from "~/chat/vue/widget/form/ChatForm.vue";
import Dictionary from "~/ts/library/Dictionary";
import PaymentSystemSelector from "~/chat/vue/widget/tabs/payment/PaymentSystemSelector.vue";
import {IPaymentSystemSelectorModel} from "~/chat/vue/widget/tabs/payment/PaymentFormInterface";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {WidgetStore} from "~/chat/ts/store/Widget";
import ChatApiResult from "~/chat/ts/service/request/ChatApiResult";
import {IWidgetPaymentTabContent} from "~/chat/ts/data/ITab";
import AnalyticCounters from "~/chat/ts/service/AnalyticCounters";
import {__} from "~/ts/library/Translate";
import {useTabContentProps} from "~/chat/vue/widget/tabs/useTabContent";
import {computed, getCurrentInstance, ref} from "vue";
import {PaymentSystemFrontendFormParamsInterface} from "~/core-ui/vue/payment/PaymentSystemFrontendFormParamsInterface";
import CoreUiPaymentForm from "~/core-ui/vue/payment/CoreUiPaymentForm.vue";


const __default__ = {
    name: "PaymentFormContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useTabContentProps()
},
  setup(__props) {

const STEP_START = "start";
const STEP_FORM = "form";
const STEP_SELECT_PAYMENT_SYSTEM = "paymentSystem";
const STEP_FINISH = "finish";

function evalInContext(js: string, context: any) {
    //# Return the results of the in-line anonymous function we .call with the passed context
    return function () {
        return eval(js);
    }.call(context);
}

let props = __props;

let step = ref(STEP_START);
let billId = ref<string>();
let formModel = ref<Dictionary<any>>();
let formHtml = ref<string>();
let hasButton = ref(true);

async function onBillCreated(newBillId: string) {
    billId.value = newBillId;
    step.value = STEP_FORM;
}

function onFormApply() {
    step.value = STEP_SELECT_PAYMENT_SYSTEM;
}

let instance = getCurrentInstance().proxy;

let form = ref<PaymentSystemFrontendFormParamsInterface>();

function successCallback(text: string) {
    (new ChatApiResult({
        code: 1,
        descr: text
    })).showMessage(instance);
}

function errorCallback(text: string) {
    (new ChatApiResult({
        code: 0,
        descr: text
    })).showMessage(instance);
}

function closeCallback() {
    WidgetStore.close();
}

let button = computed(() => (props.tab.content as IWidgetPaymentTabContent).button ?? __('SEND'));

async function onPaymentSystemSelect(value: IPaymentSystemSelectorModel) {
    if (value.paymentSystemId && value.typeId) {
        let result = await ChatApiRequest.make({
            method: "loadFormForBill",
            p: {
                billID: billId.value,
                formID: props.tab.id,
                psID: value.paymentSystemId,
                psType: value.typeId,
                paymentComment: props.paramsFromOperator ? props.paramsFromOperator.paymentComment : null,
                contacts: formModel.value,
                currentUrl: window.location.href,
                version: "vue",
                button: (props.tab.content as IWidgetPaymentTabContent).button
            }
        });
        if (result.isSuccess()) {
            form.value = result.getParam("form");
            /*
            hasButton.value = form.indexOf("<button") > -1;
            if (result.getParam("type") == "html") {
                formHtml.value = form;
            } else {
                formHtml.value = null;

                evalInContext(form, {
                    loadScript: (url: string, callback: () => {}) => {
                        var script = document.createElement("script");
                        script.type = "text/javascript";
                        script.onload = callback;
                        script.onerror = callback;
                        script.async = true;
                        script.src = url;
                        document.getElementsByTagName("head")[0].appendChild(script);
                    },
                    close: () => {
                        WidgetStore.close();
                    },
                    showMessage: (text: string) => {
                        (new ChatApiResult({
                            code: 1,
                            descr: text
                        })).showMessage(instance);
                    }
                });
            }
            */
            step.value = STEP_FINISH;

            AnalyticCounters.send(
                "Payment form submited",
                __("EVENT_SEND_FORM", props.tab.title), `Payment form submited ${props.tab.id}`
            );

        } else {
            result.showMessage(instance);
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    name: "list"
  }, {
    default: _withCtx(() => [
      (_unref(step) === 'start')
        ? (_openBlock(), _createBlock(PaymentSumSelector, {
            key: "start",
            content: _ctx.tab.content,
            "params-from-operator": _ctx.paramsFromOperator,
            onInput: onBillCreated
          }, null, 8, ["content", "params-from-operator"]))
        : (_unref(step) === 'form')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(ChatForm, {
                modelValue: _unref(formModel),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formModel) ? (formModel).value = $event : formModel = $event)),
                button: _unref(__)('CONTINUE'),
                form: _ctx.tab.content.form,
                onApply: onFormApply
              }, null, 8, ["modelValue", "button", "form"])
            ]))
          : (_unref(step) === 'paymentSystem')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(PaymentSystemSelector, {
                  content: _ctx.tab.content,
                  onInput: onPaymentSystemSelect
                }, null, 8, ["content"])
              ]))
            : (_unref(step) === 'finish')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Всё готово к оплате", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    (_unref(hasButton))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Кликните по кнопке ниже, чтобы перейти на сайт платёжной системы. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, " Сейчас откроется окно платёжной системы. "))
                  ]),
                  (_unref(form))
                    ? (_openBlock(), _createBlock(CoreUiPaymentForm, {
                        key: 0,
                        "success-callback": successCallback,
                        "error-callback": errorCallback,
                        form: _unref(form),
                        "close-callback": closeCallback
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "primary submit b",
                              textContent: _toDisplayString(_unref(button))
                            }, null, 8, _hoisted_8)
                          ])
                        ]),
                        _: 1
                      }, 8, ["form"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})